module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.ba0110cb.svg";